var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M437.019,437.02c-99.974,99.974-262.064,99.974-362.039,0c-99.974-99.974-99.974-262.065,0-362.04 c0.036,0,230.058-67.967,330.033,32.007S437.088,436.95,437.019,437.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M437.019,437.02c99.974-99.974,99.974-262.065,0-362.04s-262.064-99.974-362.039,0L437.019,437.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M322.916,322.941c-10.516,4.13-22.735,3.692-33.336-2.257c-18.73-10.512-25.416-34.306-14.901-53.039 l-3.192-1.79c32.071-7.733,55.798-36.843,55.382-71.195c-0.258-21.357-9.801-40.464-24.728-53.538l-23.373,23.946 c8.836,7.042,14.565,17.844,14.712,29.997c0.26,21.48-17.002,39.167-38.481,39.426l0.045,3.657 c-22.733-23.906-59.805-29.899-89.346-12.363c-18.366,10.904-30.14,28.72-34.001,48.185l32.424,8.27 c1.681-11.174,8.17-21.536,18.621-27.741c18.471-10.965,42.419-4.857,53.384,13.613l3.148-1.867 c-9.338,31.638,4.007,66.741,33.966,83.557c18.626,10.454,39.942,11.743,58.73,5.354L322.916,322.941z M255.268,256.747 L255.268,256.747l-0.002,0.001L255.268,256.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEACF"
    },
    d: "M350.786,173.381l-18.094,64.571l-54.29-10.025l-34.946-72.035l-94.407,33.501l-7.445-20.98 l-24.7-3.043l18.611,52.449l64.969-16.616l18.463,52.029l-44.912,66.281l76.217,65.006l-14.447,16.937l9.715,22.915l36.118-42.344 l-46.874-47.957l35.827-42.003l79.858,5.754l18.189-98.51l21.891,4.043l14.989-19.87L350.786,173.381z M255.981,257.742v0.002 V257.742L255.981,257.742z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBt);
export default __webpack_public_path__ + "static/media/bt.b08ee88074481b97a614b0bb54e127b7.svg";
export { ForwardRef as ReactComponent };